import { render, staticRenderFns } from "./ConfiguracaoNotaFiscal.vue?vue&type=template&id=4a584fb2&"
import script from "./ConfiguracaoNotaFiscal.vue?vue&type=script&lang=js&"
export * from "./ConfiguracaoNotaFiscal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports